import { render, staticRenderFns } from "./withdrawalReviewDetail.vue?vue&type=template&id=71be15ae&scoped=true"
import script from "./withdrawalReviewDetail.vue?vue&type=script&lang=js"
export * from "./withdrawalReviewDetail.vue?vue&type=script&lang=js"
import style0 from "./withdrawalReviewDetail.vue?vue&type=style&index=0&id=71be15ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be15ae",
  null
  
)

export default component.exports